function getYoutubeEmbed(htmlText) {
    // RegEx per trovare i link di YouTube e rimuovere query string
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^"&?/\s]{11})/g;

    // Funzione di sostituzione per convertire il link in iframe
    const replaceWithIframe = (match, prefix, videoId) => {
        return `
            <iframe class="youtube-responsive-iframe" src="https://www.youtube.com/embed/${videoId}" 
                    title="YouTube video player" frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen></iframe>`;
    };

    // Sostituzione dei link di YouTube con i relativi iframe
    return htmlText.replace(youtubeRegex, replaceWithIframe);
}

export default getYoutubeEmbed